import React, { useEffect, useState } from 'react';
import { Step, StepLabel, Stepper, StepProps } from '@mui/material';
import { Promotion, PromotionStatus, RewardDeliveryType } from '../Promotion.model';
import { GameOwnershipValidation } from './GameOwnershipValidation';
import { ProviderLinkValidation } from './ProviderLinkValidation';
import { GameIds } from '../../my-games/MyGames.model';
import { ClaimReward } from './ClaimReward';
import { RewardProviderSelection } from './RewardProviderSelection';

interface Props {
  promotion: Promotion;
}

enum ClaimStep {
  Link,
  Validation,
  Reward,
  Redeem,
}
export function ClaimPromotion({ promotion }: Props): JSX.Element {
  const [steps, setSteps] = useState<ClaimStep[]>([]);
  const [currentStepIndex, setCurrentStepIndex] = useState<number>(0);
  const [requiredGameId, setRequiredGameId] = useState<GameIds>(null);
  const [selectedProvider, setSelectedProvider] = useState<string>(null);

  useEffect(() => {
    setRequiredGameId(promotion.promotionData.requiredGameIds[0]);
    if (promotion.promotionData?.rewardDeliveryType === RewardDeliveryType.Direct) {
      setSteps([ClaimStep.Link, ClaimStep.Validation, ClaimStep.Reward, ClaimStep.Redeem]);
    } else {
      setSteps([ClaimStep.Link, ClaimStep.Validation, ClaimStep.Redeem]);
    }
  }, [promotion]);

  const nextStep = (): void => setCurrentStepIndex(currentStepIndex + 1);

  const selectProvider = (provider: string): void => {
    setSelectedProvider(provider);
    setCurrentStepIndex(currentStepIndex + 1);
  };

  const resetProvider = (): void => {
    setSelectedProvider(null);
    setCurrentStepIndex(currentStepIndex - 1);
  };

  return (
    <>
      <Stepper activeStep={currentStepIndex}>
        {steps.map((label) => {
          const stepProps: StepProps = {};
          if (promotion?.userData?.status === PromotionStatus.Claimed) {
            stepProps.completed = true;
          }
          return (
            <Step key={label} {...stepProps}>
              <StepLabel />
            </Step>
          );
        })}
      </Stepper>
      <div className='claim-promotion-content'>
        {steps[currentStepIndex] === ClaimStep.Link
        && <ProviderLinkValidation requiredGameId={requiredGameId} nextStep={nextStep} />}
        {steps[currentStepIndex] === ClaimStep.Validation
        && <GameOwnershipValidation requiredGameId={requiredGameId} nextStep={nextStep} />}
        {steps[currentStepIndex] === ClaimStep.Reward
        && <RewardProviderSelection promotionData={promotion.promotionData} selectProvider={selectProvider} />}
        {steps[currentStepIndex] === ClaimStep.Redeem
        && <ClaimReward promotion={promotion} provider={selectedProvider} previousStep={resetProvider} />}
      </div>
    </>
  );
}
